
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import ScoutSidebar from '@/components/scout/ScoutSidebar';
import ScoutNavbar from '@/components/scout/ScoutNavbar';

const ScoutDashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <ScoutNavbar toggleSidebar={toggleSidebar} />
      <div className="flex flex-1 h-full relative">
        <ScoutSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 overflow-auto w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ScoutDashboardLayout;
